import React, {useEffect, useRef, useState, useCallback} from 'react';
import mainStyles from 'components/homeParallax/HomeParallax.module.scss';
import styles from './MicroInfluencers.module.scss'
import panelStyles from "components/homePanels/Panels.module.scss";
import {microData} from './MicroInfluencer.data';
import MicroProfile from "components/homePanels/j_microInfluencers/microProfile/MicroProfile";
import MouseMove from "utils/MouseMove";
import PanelAnimations from "utils/PanelAnimations";
import ImageWrapper from "components/imageWrapper/ImageWrapper";
import {isMobileDevice} from "utils/Device";
import Tilt from "utils/Tilt";
import {useDispatch, useSelector} from "react-redux";
import {gsap} from "gsap";
import {buttonClick} from "utils/Helpers";

/** TODO try this https://codepen.io/loxks/details/KKpVvVW for better sidescroll **/

const MicroInfluencers = (props) => {

    const accessible = useSelector(state => state.accessible);
    const dispatch = useDispatch()
    const foreGround = useRef();
    const backGround = useRef();
    const fixedStage = useRef();
    const isMobile = isMobileDevice();
    const title = useRef();
    const left = useRef();
    const right = useRef();

    const slider = useRef();
    const clickAction = useRef();
    const activeElement = useRef();
    const [activeInfluencer, setActiveInfluencer] = useState(null);


    /** on load screen reader focus on title **/
    useEffect(()=>{

        setTimeout(()=>{
            if(props.status === 'active' && accessible.siteEntered){
                if(title.current) title.current.focus();
                if(slider.current) {
                    let width = slider.current.scrollWidth - window.innerWidth
                    slider.current.scrollLeft = (width * 0.5) - 260;
                    slider.current.onscroll = () =>{
                        if(left.current) left.current.disabled = slider.current.scrollLeft === 0;
                        if(right.current) right.current.disabled = slider.current.scrollLeft === width;
                    }
                }
            }
        }, 1000)

    }, [props.status,accessible.siteEntered])

    useEffect(()=>{
        if(title.current && activeInfluencer === null) title.current.focus();
    },[activeInfluencer])

    const buildSlider = useCallback(()=>{
        let isDown = false;
        let startX;
        let scrollLeft;

        /** todo check for touchstart/touchmove events (surface tablet ) **/

        slider.current.addEventListener('mousedown', (e) => {
            isDown = true;
            slider.current.classList.add('active');
            startX = e.pageX -  slider.current.offsetLeft;
            scrollLeft =  slider.current.scrollLeft;
            cancelMomentumTracking();
        });


        slider.current.addEventListener('mouseleave', () => {
            isDown = false;
            slider.current.classList.remove('active');
        });


        slider.current.addEventListener('mouseup', () => {
            isDown = false;
            slider.current.classList.remove('active');
            beginMomentumTracking();
        });


        slider.current.addEventListener('mousemove', (e) => {
            if(!isDown) return;
            e.preventDefault();
            const x = e.pageX -  slider.current.offsetLeft;
            const walk = (x - startX) * 3; //scroll-fast
            let prevScrollLeft =  slider.current.scrollLeft;
            slider.current.scrollLeft = scrollLeft - walk;
            velX =  slider.current.scrollLeft - prevScrollLeft;

        });

        // Momentum

        let velX = 0;
        let momentumID;

        slider.current.addEventListener('wheel', () => {
            cancelMomentumTracking();
        });

        function beginMomentumTracking(){
            cancelMomentumTracking();
            momentumID = requestAnimationFrame(momentumLoop);
        }
        function cancelMomentumTracking(){
            cancelAnimationFrame(momentumID);
        }
        function momentumLoop(){
            slider.current.scrollLeft += velX;

            velX *= 0.95;
            if (Math.abs(velX) > 0.5){
                momentumID = requestAnimationFrame(momentumLoop);
            }
        }
    }, []);

    useEffect(()=>{
        if(slider.current && !isMobile) buildSlider()
    }, [buildSlider, isMobile])

    function keyboardSelection(influencer){
        setActiveInfluencer(influencer)
        dispatch({ type: "SET_ACCESSIBLE",
            payload: {
                ...accessible,
                exploring: influencer !== null
            }
        });
        clickAction.current = true;
    }

    function selectInfluencer(influencer){

        if(clickAction.current){

            setActiveInfluencer(influencer)
            dispatch({ type: "SET_ACCESSIBLE",
                payload: {
                    ...accessible,
                    exploring: influencer !== null,
                    microModal: influencer !== null
                }
            });

        } else {
            if(activeElement.current) activeElement.current.removeEventListener('mousemove', setClickFalse);
        }
    }

    function setClickFalse(){
        clickAction.current = false
    }

    function dragOrClick(e){

        activeElement.current = e.currentTarget;
        clickAction.current = true;
        activeElement.current.addEventListener('mousemove', setClickFalse);

    }

    function sideScroll(dir){
        let amount = window.innerWidth *.80;
        let scrollAmount = dir === 'right' ? amount : -amount;
        gsap.to(slider.current, { duration: 0.5, scrollTo: {x:slider.current.scrollLeft + scrollAmount}})
    }

    function buildCreators(){

        let creators = [];
        let combo = [];
        let reducer = microData.length;

         let index = 0;
         microData.forEach((creator, creatorIndex)=>{
             reducer--;

             if(index === 4) index = 0;

             switch (index) {
                 case 0: {
                     creators.push(
                         <div key={creatorIndex} className={`${styles.slide} ${styles.slide1} ${isMobile ? styles.device : ''}`}>
                             <div tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'} aria-label={`${creator.name} profile image`} onKeyDown={(e)=>buttonClick(e, ()=>{keyboardSelection(creator.profile)})} className={styles.slideItem}
                                  onMouseDown={(e)=>dragOrClick(e)}
                                  onMouseUp={()=>selectInfluencer(creator.profile)}>
                                 <h6>{creator.name}</h6>
                                 <div className={styles.wide}>
                                     <ImageWrapper set={{default:creator.portrait}} alt={creator.name}/>
                                 </div>
                             </div>
                         </div>
                     )
                     break;
                 }
                 case 1: {
                     creators.push(
                         <div key={creatorIndex} className={`${styles.slide} ${styles.slide2} ${isMobile ? styles.device : ''}`}>
                             <div tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'} aria-label={`${creator.name} profile image`} onKeyDown={(e)=>buttonClick(e, ()=>keyboardSelection(creator.profile))} className={styles.slideItem}
                                  onMouseDown={(e)=>dragOrClick(e)}
                                  onMouseUp={()=>selectInfluencer(creator.profile)}>
                                 <div className={styles.tall}>
                                     <ImageWrapper set={{default:creator.portrait}} alt={creator.name}/>
                                     <h6>{creator.name}</h6>
                                 </div>
                             </div>
                         </div>
                     )
                     break;
                 }
                 case 2: {
                     combo.push(
                         <div tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'} aria-label={`${creator.name} profile image`} onKeyDown={(e)=>buttonClick(e, ()=>keyboardSelection(creator.profile))} key={`${creatorIndex}_large`} className={`${styles.slideItem} ${styles.large}`}
                              onMouseDown={(e)=>dragOrClick(e)}
                              onMouseUp={()=>selectInfluencer(creator.profile)}>
                             <h6>{creator.name}</h6>
                             <div className={styles.wide}>
                                 <ImageWrapper set={{default:creator.portrait}} alt={creator.name}/>
                             </div>
                         </div>
                     )

                     if(reducer === 0){

                         creators.push(
                             <div key={creatorIndex} className={`${styles.slide} ${styles.slide3} ${isMobile ? styles.device : ''}`}>
                                 {combo}
                             </div>
                         );
                         combo = [];

                     }
                     break;
                 }
                 case 3: {
                     combo.push(
                         <div tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'} aria-label={`${creator.name} profile image`} onKeyDown={(e)=>buttonClick(e, ()=>keyboardSelection(creator.profile))} key={`${creatorIndex}_small`} className={`${styles.slideItem} ${styles.small}`}
                              onMouseDown={(e)=>dragOrClick(e)}
                              onMouseUp={()=>selectInfluencer(creator.profile)}>
                             <div className={styles.wide2}>
                                 <ImageWrapper set={{default:creator.portrait}} alt={creator.name}/>
                                 <h6>{creator.name}</h6>
                             </div>

                         </div>
                     )
                     creators.push(
                         <div key={creatorIndex} className={`${styles.slide} ${styles.slide3} ${isMobile ? styles.device : ''}`}>
                             {combo}
                         </div>
                     );
                     combo = [];
                     break;
                 }

                 default: break;

             }

             index++;


        })

        return creators;
    }

    return (

        <>

            <div aria-hidden={accessible.modalOpen} ref={fixedStage} className={`${panelStyles.fixedStage} ${panelStyles.sideScroll} ${styles.microInfluencers}`} style={{zIndex: props.zIndex}}>
                <div aria-hidden={activeInfluencer} ref={foreGround} className={`${styles.sliderForeGround}`}>

                    <div tabIndex={-1} ref={title} className={styles.spotlightTitle}>
                        <h3>Originals Spotlight</h3>
                    </div>

                    <div className={styles.controls}>
                        <button disabled={accessible.modalOpen} aria-label={'Scroll left'} ref={left} className={`${styles.left}`} onClick={()=>sideScroll('left')}>
                            <img src={'https://msobd-storage.azureedge.net/images/customWraps/arrow.png'} alt={'Scroll left'}/>
                        </button>
                    </div>

                    <div ref={slider} className={styles.sideSwipe}>
                        {buildCreators()}
                    </div>

                    <div className={styles.controls}>
                        <button disabled={accessible.modalOpen} aria-label={'Scroll right'} ref={right} className={`${styles.right}`} onClick={()=>sideScroll('right')}>
                            <img src={'https://msobd-storage.azureedge.net/images/customWraps/arrow.png'} alt={'Scroll right'}/>
                        </button>
                    </div>

                </div>

                <ImageWrapper aria-hidden={true} ref={backGround} className={panelStyles.backGround} set={{
                    400: 'https://msobd-storage.azureedge.net/images/bg-smoke-430x650.jpg',
                    700: 'https://msobd-storage.azureedge.net/images/bg-smoke-800x790.jpg',
                    1250: 'https://msobd-storage.azureedge.net/images/bg-smoke-1350.jpg',
                    default: 'https://msobd-storage.azureedge.net/images/bg-smoke.jpg'
                }} alt={''}/>

                {/*<div className={styles.scrollText}>Grab to scroll</div>*/}

                <span className={mainStyles.accessibleContent} tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'} onKeyDown={buttonClick} aria-label={`Navigate to previous section`} onClick={props.prevPanel}/>
                <span className={mainStyles.accessibleContent} tabIndex={accessible.siteEntered && !accessible.modalOpen ? 0 : null} role={'button'} onKeyDown={buttonClick} aria-label={'Navigate to next section'} onClick={props.nextPanel}/>

            </div>


            {activeInfluencer && <MicroProfile creator={activeInfluencer} close={selectInfluencer}/>}



            <PanelAnimations skipAnimation={props.skipAnimation} fixedStage={fixedStage}
                             backGround={backGround} foreGround={foreGround} panel={'spotlight'}/>

            <MouseMove status={props.status} backGround={backGround} />
            <Tilt backGround={backGround}/>
        </>
    )
};

export default MicroInfluencers
